import 'react-toastify/dist/ReactToastify.css';
import * as Toastify from 'react-toastify';
import styled from 'styled-components';
import { useEffect } from 'react';

import { useNotificationsDrawerView } from '#/features/notifications/drawer-context';

import { NOTIFICATIONS_DRAWER_WIDTH } from '#/components/common/notifications/settings';

export default function ToastContainer() {
  const drawerView = useNotificationsDrawerView();
  useEffect(dismissAllToastOnEsc, []);

  return (
    <StyledToastContainer
      hideProgressBar
      closeOnClick={false}
      autoClose={5000}
      closeButton={false}
      draggable={false}
      transition={noTransition}
      limit={20}
      newestOnTop
      isDrawerOpen={drawerView.isOpen}
      position="bottom-right"
    />
  );
}

function dismissAllToastOnEsc() {
  const handleKeyUp = (event: KeyboardEvent) => {
    if (event.key !== 'Escape') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    Toastify.toast.clearWaitingQueue();
    Toastify.toast.dismiss();
  };
  const options = { capture: true };
  document.addEventListener('keyup', handleKeyUp, options);
  return () => document.removeEventListener('keyup', handleKeyUp, options);
}

const noTransition = Toastify.cssTransition({
  collapse: false,
  duration: 0,
  enter: 'dex-no-transition',
  exit: 'dex-no-transition',
});

interface ToastContainerProps {
  isDrawerOpen: boolean;
}

const StyledToastContainer = styled(
  Toastify.ToastContainer,
)<ToastContainerProps>`
  &.Toastify__toast-container {
    width: unset;

    &--top-right {
      top: 68px;
      right: 16px;
      left: unset;
      ${({ isDrawerOpen }) =>
        isDrawerOpen && `right: ${NOTIFICATIONS_DRAWER_WIDTH + 10}px;`}
    }

    &--bottom-right {
      ${({ isDrawerOpen }) =>
        isDrawerOpen && `right: ${NOTIFICATIONS_DRAWER_WIDTH + 10}px;`}
    }
  }
  .Toastify__toast {
    background: unset;
    min-height: unset;
    padding: unset;
    cursor: unset;
    font: unset;

    margin-bottom: 8px;
  }
`;
